import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import { GamesIntro, NewsBlock } from '../components';

class Home extends Component<IRootStoreProps> {
  static contextType = AppContext;

  render(): React.ReactNode {
    const breakPoint = this.context as AppContextValue;
    const { user } = this.props.store;

    if (breakPoint?.isMobile) {
      return (
        <>
          <NewsBlock newsList={user.newsList} />
          <GamesIntro isAuth={user.isAuth} />
        </>
      );
    }
    return <GamesIntro isAuth={user.isAuth} />;
  }
}

export const HomePage: WithoutStore = withStore(observer(Home));
